import React, { useEffect } from "react";
import { Typography, Stack, Box, Divider, useToast } from "digiwash-components";

import RowAddress from "../../components/RowAddress";
import useFavoriteLocations from "../../ducks/user/hooks/useFavoriteLocations";
import SkeletonUserAddressesList from "../../components/SkeletonUserAddressesList";

function AddressesCard() {
  let { data, isValidating, error } = useFavoriteLocations();
  let toast = useToast();
  useEffect(() => {
    if (error) {
      toast.show(error, {
        data: { type: "danger" },
      });
    }
  }, [error]);
  return (
    <Stack direction="vertical" alignment="stretch">
      {isValidating && (
        <>
          <Divider size="l" />
          <SkeletonUserAddressesList />
        </>
      )}
      {!isValidating && !data && error ? (
        <Stack distribution="center">
          <Typography>{error}</Typography>
        </Stack>
      ) : null}
      <Divider size="l" />
      {!isValidating && !!data
        ? data.map((address: any) => (
            <>
              <RowAddress data={address} />
              <Divider size="l" />
            </>
          ))
        : null}
      {!isValidating && data && data.length === 0 && (
        <Box p="m">
          <Typography color="neutrals.700" ff="mainBold" alignment="center">
            شما تا به حال آدرسی ثبت نکرده اید.
          </Typography>
        </Box>
      )}
    </Stack>
  );
}

export default AddressesCard;
